import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { BACKEND_URL } from "@/lib/api";
import { money, dt } from "@/lib/format";
import { useBrand } from "@/components/BrandProvider";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export default function PrintOrder() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  const marca = useBrand() || {};
  const logoImpresion = marca.logo_url || marca.logo_icono_url; // Fix K: principal → ícono → texto

  useEffect(() => { api.get(`/orders/${id}`).then((r) => setO(r.data)).catch(() => setO(null)); }, [id]);

  if (!o) return <div className="p-8 text-center text-muted-foreground">Cargando…</div>;

  return (
    <div className="max-w-sm mx-auto p-6 font-mono text-sm" data-testid="print-order-page">
      <div className="no-print mb-4 flex justify-end">
        <Button onClick={() => window.print()} className="rounded-full gap-2" data-testid="print-button">
          <Printer className="h-4 w-4" /> Imprimir
        </Button>
      </div>
      <div className="text-center mb-3">
        {logoImpresion ? (
          <img src={`${BACKEND_URL}${logoImpresion}`} alt={marca.nombre_comercial || "Logo"}
            className="mx-auto mb-1 w-[140px] max-h-24 object-contain" data-testid="print-order-logo" />
        ) : (
          <p className="font-bold text-base">{(marca.nombre_comercial || "Marthitashop").toUpperCase()}</p>
        )}
        <p>Pedido #{o.numero}</p>
        <p className="text-xs">{dt(o.created_at)}</p>
      </div>
      <div className="border-t border-dashed border-black py-2">
        <p>{o.cliente_nombre}</p>
        <p>{o.cliente_telefono}</p>
        <p>{o.direccion_entrega}</p>
        {o.zona_envio && <p>Zona: {o.zona_envio}</p>}
      </div>
      <div className="border-t border-dashed border-black py-2">
        {o.items.map((it, i) => (
          <div key={i} className="flex justify-between"><span>{it.cantidad}x {it.nombre}</span><span>{money(it.precio_unitario * it.cantidad)}</span></div>
        ))}
      </div>
      <div className="border-t border-dashed border-black py-2">
        <div className="flex justify-between"><span>Subtotal</span><span>{money(o.subtotal)}</span></div>
        {o.descuento > 0 && <div className="flex justify-between"><span>Descuento</span><span>-{money(o.descuento)}</span></div>}
        {o.costo_envio > 0 && <div className="flex justify-between"><span>Envío</span><span>{money(o.costo_envio)}</span></div>}
        <div className="flex justify-between font-bold"><span>TOTAL</span><span>{money(o.total)}</span></div>
      </div>
      <p className="text-center text-xs mt-3">¡Gracias por tu compra! 💕</p>
    </div>
  );
}
